import Swiper, { FreeMode } from 'swiper';

let crossSells = Array.from(document.getElementsByClassName('cross-sells-container'));

crossSells.forEach(function (item) {
    let id = '#' + item.getAttribute('id');

    let swiper = new Swiper(id, {
        modules: [FreeMode],
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: {
            enabled: true,
            sticky: true,
        },
    });
})